<template>
  <div>
    <div class="horizontal-scroll-container">
      <div
        class="scroll-button left"
        @click="scrollLeft"
        :disabled="isLeftDisabled"
        @mouseenter="handleMouseEnter('left')"
        @mouseleave="handleMouseLeave('left')"
      >
        <img :src="leftButtonImage" alt="" />
      </div>

      <div class="scroll-wrapper" ref="scrollWrapper" v-loading="loading1">
        <div class="scroll-content" ref="scrollContent">
          <div
            v-for="(item, index) in items"
            :key="index"
            class="scroll-item"
            :class="{ active: activeIndex === index }"
            @click="selectItem(index, item)"
          >
            {{ item.area_code }}
          </div>
        </div>
      </div>
      <div
        class="scroll-button right"
        @click="scrollRight"
        :disabled="isRightDisabled"
        @mouseenter="handleMouseEnter('right')"
        @mouseleave="handleMouseLeave('right')"
      >
        <img :src="rightButtonImage" alt="" />
      </div>
    </div>
    <div class="dfts">
      <div class="dftsItem" v-loading="loading2">
        <div
          class="dftsback"
          @mouseenter="showDescription = true"
          @mouseleave="showDescription = false"
        >
          <div class="background-base"></div>
          <div
            class="image-container"
            :class="{ 'hover-active': showDescription }"
          >
            <img :src="getImagePath2(imagesList)" alt="" />
          </div>
          <transition name="fade">
            <div class="description-overlay" v-show="showDescription">
              <div class="description-text">
                {{ descriptionText }}
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="dftsList" v-loading="loading3">
        <!-- <div
          class="dfteItem"
          v-for="(item, index) in dataList"
          :key="index"
          v-show="index < 5"
          @click="datebaseinfo(item)"
        >
       
        </div> -->
        <div class="newlist2">
          <div
            class="newlistitem2"
            v-for="(item, index) in dataList"
            :key="index"
            v-show="index < 5"
          >
            <div class="newlistitem2_div">
              <div class="list8">
                <p class="list1title8" @click="datebaseinfo(item)">
                  {{ item.title }}
                </p>

                <div class="tssku_icon">
                  <img src="" alt="" />
                  <p>网络访问 | 镜像访问</p>
                </div>
              </div>
              <div class="iconlist8">
                <p
                  v-html="item.description"
                  style="width: 578px; overflow: hidden"
                ></p>
              </div>
            </div>
            <div class="cardicon9">
              <img
                @click.stop="triggerParentEvent(item, $event)"
                :src="cardicon"
                alt=""
              />
            </div>
          </div>
          <div class="jpzskmore" @click="gotoList">查看更多></div>
        </div>
      </div>
    </div>
    <!-- <div class="city_but">
      <div class="but" @click="gotoList">
        <div>查看更多 <span>&nbsp</span> ></div>
      </div>
    </div> -->
  </div>
</template>

<script setup>
import { ArrowLeft, ArrowRight } from "@element-plus/icons-vue";
import CustomPopover from "@/views/components/CustomPopover.vue";

import {
  ref,
  onMounted,
  onBeforeUnmount,
  watch,
  computed,
  nextTick,
} from "vue";
import { defineProps, defineEmits } from "vue";
import defaultImage from "@/assets/headerimage/矩形 2@2x.png";
import zlpng from "@/assets/headerimage/zhonglou.png";
import leftjt from "@/assets/headerimage/zuojt.png";
import leftjt2 from "@/assets/headerimage/zuojt02.png";
import leftjt3 from "@/assets/headerimage/zuojt03.png";
import rightjt from "@/assets/headerimage/youjt.png";
import rightjt2 from "@/assets/headerimage/youjt02.png";
import rightjt3 from "@/assets/headerimage/youjt01.png";
import more from "@/assets/headerimage/lujin2.png";
import { useRouter } from "vue-router";
import imge3 from "@/assets/headerimage/wl.png";
import imge4 from "@/assets/headerimage/jx.png";
import imge5 from "@/assets/headerimage/jj.png";
import imge9 from "@/assets/headerimage/card001.png";
import cardicon from "@/assets/newimages/cardicon.png";

import bus from "@/mitt/bus.js";
const loading1 = ref(false);
const loading2 = ref(false);
const loading3 = ref(false);
const showDescription = ref(false);
const descriptionText = ref(
  "这里是关于这个图片的详细文字介绍，可以替换为动态内容。"
);
const imagesList = ref("");
const router = useRouter();
const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  itemWidth: {
    type: Number,
    default: 99,
  },
  visibleItems: {
    type: Number,
    default: 5,
  },
  province: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(["item-selected"]);

const dataList = ref([]);
const originalData = ref([]);
const scrollWrapper = ref(null);
const areaCode = ref(null);
const scrollContent = ref(null);
const scrollPosition = ref(0);
const activeIndex = ref(0);
const hoverIndex = ref(-1);
const currentImage = ref("");
const lableBtnRef = ref(null);

const leftButtonImage = ref(leftjt);
const rightButtonImage = ref(rightjt);
const leftButtonHover = ref(false);
const rightButtonHover = ref(false);

const gotoList = () => {
  localStorage.setItem("lastSelectTime", Date.now().toString());
  router.push({
    path: "LocalCharaDatabase",
    query: { id: areaCode.value, name: "dfts" },
  });
};

const datebaseinfo = (data) => {
  localStorage.setItem("lastSelectTime", Date.now().toString());
  router.push({
    name: "newDatabaseInfo",
    query: { id: data.id },
  });
};
const triggerParentEvent = async (card, event) => {
  bus.emit("sendMsg", {
    message: "Hello from SenderComponent!",
    card,
    event,
    lableBtn: lableBtnRef.value,
  });
};

const handleImageError = (event) => {
  event.target.src = defaultImage;
  event.target.onerror = null;
};

const isRightDisabled = computed(() => {
  if (!scrollWrapper.value) return true;
  // 检查是否已经滚动到最后一个项
  const visibleItemsEnd = scrollPosition.value + wrapperWidth.value;
  return visibleItemsEnd >= contentWidth.value;
});

const isLeftDisabled = computed(() => {
  return scrollPosition.value === 0;
});

const wrapperWidth = computed(() => {
  return props.itemWidth * props.visibleItems;
});

const contentWidth = computed(() => {
  return props.itemWidth * props.items.length;
});

const selectItem = async (index, item) => {
  loading2.value = true;
  if (!item?.area_code) return;
  areaCode.value = item.area_code;
  activeIndex.value = index;
  await filteredWith(item.area_code);
  if (props.province.length > 0) {
    const beijingItem = props.province.find(
      (item) => item.name === areaCode.value
    );

    const basePath = "/ckbop/profile/knowledge/image/2025/04/10/";
    descriptionText.value = beijingItem ? beijingItem.description : "";
    imagesList.value = beijingItem.imgUrl;

    loading2.value = false;
  }
  await nextTick();
};

const filteredWith = async (areaCode) => {
  try {
    if (!originalData.value.length) return;

    const filtered = originalData.value
      .map((parent) => {
        const knowledges =
          parent?.knowledges?.filter((k) => k?.areaCode === areaCode) || [];
        return knowledges.length ? { ...parent, knowledges } : null;
      })
      .filter(Boolean);

    dataList.value = filtered.length ? [...filtered[0].knowledges] : [];
    loading3.value = false;

    await nextTick();
  } catch (error) {
    loading3.value = true;
    console.error("Filter error:", error);
    dataList.value = [];
  }
};

watch(
  [() => props.items, () => props.province],
  ([newItems, newProvince]) => {
    loading1.value = true;

    // 处理 items 变化
    if (newItems?.length > 0) {
      originalData.value = [...newItems];
      dataList.value = [...newItems];

      if (newItems[0]?.area_code) {
        selectItem(0, newItems[0]);
      }
    } else {
      originalData.value = [];
      dataList.value = [];
    }

    // 处理 province 变化（这里添加 province 的处理逻辑）
    if (newProvince?.length > 0) {
      // province 有数据时的处理逻辑
      // 可以在这里添加 province 相关的处理代码
    } else {
      // province 为空时的处理逻辑
    }

    loading1.value = false;
  },
  { immediate: true, deep: true }
);

const getImagePath = (filePath) => {
  const baseApi = process.env.VUE_APP_BASE_API;
  if (filePath) {
    return baseApi ? `${baseApi}/ckbop/${filePath}` : `/ckbop/${filePath}`;
  }
  return "";
};
const getImagePath2 = (filePath) => {
  const baseApi = process.env.VUE_APP_BASE_API;
  if (filePath) {
    return baseApi
      ? `${baseApi}/ckbop/profile/knowledge/image/2025/04/10/${filePath}`
      : `/ckbop/profile/knowledge/image/2025/04/10/${filePath}`;
  }
  return "";
};

const scrollLeft = () => {
  if (isLeftDisabled.value) return;

  const newPosition = Math.max(
    0,
    scrollPosition.value - props.itemWidth * Math.floor(props.visibleItems / 2)
  );
  scrollTo(newPosition);
};

const scrollRight = () => {
  if (isRightDisabled.value) return;

  const newPosition = Math.min(
    contentWidth.value - wrapperWidth.value,
    scrollPosition.value + props.itemWidth * Math.floor(props.visibleItems / 2)
  );
  scrollTo(newPosition);
};

const scrollTo = (position) => {
  if (!scrollContent.value) return;
  scrollPosition.value = position;
  scrollContent.value.style.transform = `translateX(-${position}px)`;
  // 更新按钮状态
  updateButtonStates();
};

const updateButtonStates = () => {
  if (isLeftDisabled.value) {
    leftButtonImage.value = leftjt2;
    leftButtonHover.value = false;
  } else {
    leftButtonImage.value = leftButtonHover.value ? leftjt3 : leftjt;
  }

  if (isRightDisabled.value) {
    rightButtonImage.value = rightjt2;
    rightButtonHover.value = false;
  } else {
    rightButtonImage.value = rightButtonHover.value ? rightjt3 : rightjt;
  }
};

const handleResize = () => {
  if (scrollPosition.value > contentWidth.value - wrapperWidth.value) {
    scrollTo(contentWidth.value - wrapperWidth.value);
  }
};

const handleMouseEnter = (direction) => {
  if (direction === "left") {
    if (!isLeftDisabled.value) {
      leftButtonHover.value = true;
      leftButtonImage.value = leftjt3;
    }
  } else {
    if (!isRightDisabled.value) {
      rightButtonHover.value = true;
      rightButtonImage.value = rightjt3;
    }
  }
};

const handleMouseLeave = (direction) => {
  if (direction === "left") {
    leftButtonHover.value = false;
    leftButtonImage.value = isLeftDisabled.value ? leftjt2 : leftjt;
  } else {
    rightButtonHover.value = false;
    rightButtonImage.value = isRightDisabled.value ? rightjt2 : rightjt;
  }
};

onMounted(() => {
  loading3.value = true;
  window.addEventListener("resize", handleResize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", handleResize);
});
</script>

<style scoped>
.horizontal-scroll-container {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  position: relative;
  left: 0px;
  margin-bottom: 52px;
}

.scroll-wrapper {
  width: 100%;
  overflow: hidden;
  flex-grow: 1;
}

.scroll-content {
  display: flex;
  transition: transform 0.3s ease;
  will-change: transform;
}

.scroll-item {
  flex: 0 0 v-bind('props.itemWidth + "px"');
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  background: #f1f6ff;
  /* border-radius: 4px; */
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.2s ease;
}

.scroll-item:last-child {
  margin-right: 0;
}

.scroll-item:hover {
  color: #1890ff;
}

.scroll-item.active {
  color: #1890ff;
}

.scroll-button {
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}
.scroll-button > img {
  width: 25px;
  height: 25px;
}

.scroll-button:hover:not(:disabled) {
  background-color: #f0f0f0;
}

.scroll-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.scroll-button svg {
  color: #666;
}

.scroll-button:not(:disabled):hover svg {
  color: #1890ff;
}

.city_but {
  height: 54px;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  cursor: pointer;
  /* margin-bottom: 80px; */
}

.city_but .but {
  width: 126px;
  height: 44px;
  background: #2c77ff;
  /* border-radius: 2px; */
  line-height: 44px;
  text-align: center;
  display: flex;
  justify-content: center;
  color: #fff;
}

.city_but .but:hover {
  background: #2565d9;
}

.but:hover {
  color: #fff;
}

.dfts {
  background: #f1f6ff;
  display: flex;
  justify-content: space-between;
  /* margin-top: 39px; */
}

.dftsback {
  width: 578px;
  height: 357px;
  position: relative;
  /* overflow: hidden; */
  /* border-radius: 6px; */
  cursor: pointer;
}

.background-base {
  position: absolute;
  top: 0px;
  left: 0;
  width: 100%;
  height: 337px;
  background: #2c77ff;
  transition: all 0.5s ease;
  z-index: 1;
  /* border-radius: 6px; */
}

.image-container {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 100%;
  height: calc(100% - 6px);
  transition: all 0.5s ease;
  z-index: 2;
  /* border-radius: 4px; */
  overflow: hidden;
}

.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.5s ease;
}

.dftsback .hover-active {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.dftsback .hover-active + .background-base {
  top: 20px;
  left: 20px;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
}

.description-overlay {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 100%;
  height: 100%;
  background: rgba(44, 119, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  /* border-radius: 6px; */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.dftsList {
  width: 746px;
  margin-left: 48px;
  height: 402px;
  background: #f1f6ff;
  cursor: pointer;
}

/* .dfteItem {
  width: 746px;
  height: 68px;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  line-height: 68px;
  margin-left: 25px;
  padding: 0 20px 0px 20px;
  margin-bottom: 8px;
}

.dfteItem:hover {
  background-image: url(@/assets/image/dftsbj.png);
  background-repeat: no-repeat;
  background-size: cover;
} */
.dftsTltle:hover {
  color: #2c77ff;
}

.dftsTltle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  text-align: left;
  font-style: normal;
}

.dftscbs {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  text-align: center;
  font-style: normal;
}
.infoIcon {
  width: 134px;
  display: flex;
  justify-content: space-between;
}
.Icon_item {
  width: 12px;
  height: 12px;
  margin-left: 12px;
}
.Icon_item1 {
  width: 24px;
  height: 12px;
  margin-left: 12px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  /* line-height: 17px; */
  text-align: center;
  font-style: normal;
}
.Icon_item > img {
  width: 12px;
  height: 12px;
}
.description-text {
  width: 80%;
  color: white;
  font-size: 16px;
  line-height: 1.6;
  text-align: justify;
  padding: 20px;
  font-family: PingFangSC, PingFang SC;
}

.newlistitem2 :hover {
  .list1title {
    color: #0760da;
  }
}
.newlistitem2 {
  width: 736px;
  height: 56px;
  /* border-radius: 6px; */
  display: flex;
  justify-content: space-between;
  /* padding: 10px; */
  cursor: pointer;
  position: relative;
  margin-left: 10px;
  margin-top: 15px;
  background: #fff;
  white-space: wrap;
  text-overflow: ellipsis;
  cursor: pointer;
}

.newlistitem2_div {
  margin: 2px;
  padding: 8px;
  width: 736px;
}

.newlistitem2:last-child {
  margin-bottom: 0;
}
.newlistitem2 :hover {
  .list1title {
    color: #0760da;
  }
}
.newlistitem2:hover .newlistitem2_div {
  background: linear-gradient(90deg, #f3f6ff, #d1e2ff 100%);
}

.newlistitem2:hover {
  /* background-image: url(@/assets/image/dftsbj.png);
  background-repeat: no-repeat;
  background-size: cover; */
  height: 76px;
  .iconlist8 {
    display: flex;
    padding-top: 5px;
  }
}
.iconlist8 {
  width: 600px;
  font-size: 14px;
  font-weight: 400;
  text-align: LEFT;
  color: #666666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: none;
}
.iconlist8 p {
  /* width: 578px;
  overflow: hidden; */
}
.iconlist8 div {
  width: 50px;
}
.iconlist8 div:hover {
  color: #1890ff;
  cursor: pointer;
}
.iconlist8:hover {
  display: flex;
}

.jpzskmore {
  width: 746px;
  font-size: 14px;
  font-weight: 400;
  text-align: right;
  color: #999999;
  padding-top: 17px;
}
.list8 {
  /* width: 736px; */
}
</style>
